/*
 * @Author: Vanny
 * @Date: 2020-07-02 17:45:49
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-02 17:54:52
 * @Description:
 */
// 导入进货单，上传 Excel 的规则(用户习惯记录)
export const IMPORT_PURCHASE = 'pc-import-purchase';
